import React, {Component} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {ApolloProvider} from 'react-apollo'
import {library} from '@fortawesome/fontawesome-svg-core'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {ToastContainer} from 'react-toastify'

import Project from "./app/components/Project"
import Login from "./app/components/auth/Login"
import Main from "./app/components/Main";

import client from './lib/connect'
import AuthRoute from "./app/components/HOC/AuthRoute";
import Dashboard from "./app/components/dashboard/Dashboard";
import ForgotPassword from "./app/components/auth/ForgotPassword";
import ResetPassword from "./app/components/auth/ResetPassword";

library.add(far, fas)


class App extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (

            <ApolloProvider client={client}>
                <Router>
                    <Switch>
                        <Route path="/login" exact component={Login}/>
                        <Route path="/forgot-password" exact component={ForgotPassword}/>
                        <Route path="/reset-password/:code" exact component={ResetPassword}/>
                        <AuthRoute path="/" component={Main}/>
                    </Switch>
                </Router>
                <ToastContainer/>
            </ApolloProvider>
        );
    }


}

export default App;
